import { BridgeAppraisalStatusGroupMapper } from './bridgeAppraisalStatusGroupMapper';

export const BridgeAppraisalStatusGroupOptions = Object.entries(BridgeAppraisalStatusGroupMapper.Section)
    .map(([key, value]) => ({
        value,
        label: BridgeAppraisalStatusGroupMapper.getLabels(false)[value],
    }))
    .sort((a, b) => a.value - b.value);
